var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargingStations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7V5ZM8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5V7ZM7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17V15ZM8 17C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15V17ZM3 2H21V0H3V2ZM22 3V19H24V3H22ZM21 20H3V22H21V20ZM2 19V3H0V19H2ZM3 20C2.44772 20 2 19.5523 2 19H0C0 20.6569 1.34314 22 3 22V20ZM22 19C22 19.5523 21.5523 20 21 20V22C22.6569 22 24 20.6569 24 19H22ZM21 2C21.5523 2 22 2.44772 22 3H24C24 1.34315 22.6569 0 21 0V2ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0ZM1 12H23V10H1V12ZM7 7H8V5H7V7ZM7 17H8V15H7V17Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingStations);
export default __webpack_public_path__ + "static/media/charging-stations.710bde02fa1d9d8d69e0cfa1c519ba2b.svg";
export { ForwardRef as ReactComponent };